import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import localizedFormat from "dayjs/plugin/localizedFormat";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.extend(updateLocale);
dayjs.extend(localizedFormat);
dayjs.extend(utc);

// to start schema from monday instead of sunday
["en", "zh-tw", "zh-cn"].forEach((lang) =>
  dayjs.updateLocale(lang, { weekStart: 1 })
);

export default dayjs;
